var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"playercontent"}},[_c('div',{ref:"dplayer",attrs:{"id":"dplayer"},on:{"dblclick":_vm.fullScreen}}),_c('classTest',{ref:"classTest",attrs:{"showTest":_vm.showTest,"videoCurrentTime":_vm.videoCurrentTime,"duration":_vm.duration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }